import React, { FC, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { useSignInQuery } from '../../app/authentication/sign-in';
import { PageTitle } from '../common-styles/common-styles';

const PageWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 2rem 1rem;
  flex-direction: column;
`;
const InputWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem;
  input {
    margin-left: 0.5rem;
    width: 14rem;
  }
  label {
    text-align: right;
  }
`;
const Button = styled.button`
  border-radius: 5px;
  width: 4rem;
  height: 1.5rem;
  background: lightblue;
  border: 1px solid #5c9db2;
  font-weight: 500;
  color: white;
  margin: 1rem 1rem;
  &:disabled {
    background-color: lightgray;
  }
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const ErrorWrapper = styled.div`
  color: red;
`;

const getErrorDescription = (errorCode: string): string => {
  if (errorCode === 'INVALID_LOGIN_CREDENTIALS') {
    return 'Please check the email and password!';
  }
  return 'Oops something went wrong!';
};
export const LoginForm: FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailAndPasswordValid, setEmailAndPasswordValid] = useState(false);

  const { isLoading, error, data } = useSignInQuery(email, password, emailAndPasswordValid);
  useEffect(() => {
    if (data && emailAndPasswordValid) {
      navigate('/');
    }
    if (error) {
      setEmailAndPasswordValid(false);
      console.log('<><ERROR><><', error.message, error.cause, error.name, error.stack);
    }
  }, [data, error, navigate]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setEmailAndPasswordValid(true);
  };

  if (isLoading) {
    return <div>Loading</div>;
  }
  return (
    <PageWrapper>
      <PageTitle>Login</PageTitle>
      <form onSubmit={handleSubmit}>
        <InputWrapper>
          <label>Email:</label>
          <input data-testid="email" type="text" value={email} onChange={(event) => setEmail(event.target.value)} />
        </InputWrapper>
        <InputWrapper>
          <label>Password:</label>
          <input data-testid="password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} />
        </InputWrapper>
        {error && <ErrorWrapper>{getErrorDescription(error.message)}</ErrorWrapper>}
        <ButtonWrapper>
          <Button data-testid="login-button" type="submit">
            Login
          </Button>
        </ButtonWrapper>
      </form>
    </PageWrapper>
  );
};
